var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_65_6",
    "data-name": "Component 65 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54433",
    "data-name": "Path 54433",
    d: "M17,0A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z",
    fill: "#387f75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "filter",
    d: "M.474,2.433H7.691a2.208,2.208,0,0,0,4.312,0h2.691a.474.474,0,1,0,0-.948H12a2.207,2.207,0,0,0-4.312,0H.474a.474.474,0,0,0,0,.948ZM8.588,1.96s0,0,0-.005a1.259,1.259,0,0,1,2.518,0v.007a1.259,1.259,0,0,1-2.519,0Zm6.106,10.293H12a2.207,2.207,0,0,0-4.312,0H.474a.474.474,0,0,0,0,.948H7.691A2.208,2.208,0,0,0,12,13.2h2.691a.474.474,0,0,0,0-.948ZM9.847,13.987A1.261,1.261,0,0,1,8.588,12.73v0s0,0,0-.005a1.259,1.259,0,0,1,2.518,0v.007a1.261,1.261,0,0,1-1.259,1.257Zm4.847-7.117H7.477a2.208,2.208,0,0,0-4.312,0H.474a.474.474,0,0,0,0,.948H3.165a2.207,2.207,0,0,0,4.312,0h7.217a.474.474,0,0,0,0-.948ZM6.58,7.342s0,0,0,.005a1.259,1.259,0,0,1-2.518,0V7.341a1.259,1.259,0,0,1,2.519,0Z",
    transform: "translate(9 9.248)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButton);
export default __webpack_public_path__ + "static/media/filter-button.878f94c6c0dc0b3be81f37f2abb2bd05.svg";
export { ForwardRef as ReactComponent };